/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_requestUserNotification_requestSaveNotifications } from '../models/api_requestUserNotification_requestSaveNotifications';
import type { api_requestUserNotification_responseSaveNotifications } from '../models/api_requestUserNotification_responseSaveNotifications';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RequestUserNotificationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Save multiple notifications
     * Saves multiple request user notifications at once
     * @returns api_requestUserNotification_responseSaveNotifications responseSaveNotifications
     * @throws ApiError
     */
    public postRequestUserNotificationsSave({
        body,
    }: {
        /**
         * requestSaveNotifications
         */
        body: api_requestUserNotification_requestSaveNotifications,
    }): CancelablePromise<api_requestUserNotification_responseSaveNotifications> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_notifications/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
